/**
 * Krok VYV1 — klient tisku nabidky (vyloha, letak s QR, list do sanonu).
 *
 * Co se tiskne, ROZHODUJE SERVER (`/v1/listing-print/prefs` vraci i hotove
 * `effective`): vrstveni „vychozi <- kancelar <- makler" zije jednou,
 * v `@reos/reports` — administrace si ho neopisuje.
 *
 * Nazev, cena, parametry a popis posila administrace jako HOTOVY TEXT z karty
 * (ROZHODNUTI VYV1-1 v `apps/api/src/routes/listing-print.ts`): formatuje je
 * tentyz kod, ktery je ukazal maklerovi (`listing-draft-format.ts`). Adresu,
 * fotky, logo kancelare a kontakty (makler ze session, majitel z ucastniku
 * zakazky) dopl*nuje server — z pozadavku se neberou.
 */

import type { ApiPaths } from '@reos/api-client';
import { API_BASE_URL, apiClient, downloadServerPdf } from './api.js';
import { unwrap } from './api-error.js';

export type ListingPrintPrefs =
  ApiPaths['/v1/listing-print/prefs']['get']['responses']['200']['content']['application/json'];

export type ListingPrintPreset = keyof ListingPrintPrefs['effective'];
export type ListingPrintOptions = ListingPrintPrefs['effective'][ListingPrintPreset];
export type ListingPrintPart = keyof ListingPrintOptions['parts'];
export type ListingPrintPdfBody =
  ApiPaths['/v1/cases/{caseId}/print.pdf']['post']['requestBody']['content']['application/json'];

/** Poradi predvoleb na obrazovce = poradi v zadani (vyloha, letak, sanon). */
export const LISTING_PRINT_PRESET_ORDER = ['vyloha', 'letak-qr', 'sanon'] as const satisfies readonly ListingPrintPreset[];

/** Poradi zaskrtavatek = poradi v zadani bodu 2. */
export const LISTING_PRINT_PART_ORDER = [
  'broker',
  'owner',
  'price',
  'params',
  'description',
  'map',
  'qr',
] as const satisfies readonly ListingPrintPart[];

export async function fetchListingPrintPrefs(): Promise<ListingPrintPrefs> {
  return unwrap(apiClient.GET('/v1/listing-print/prefs', {}));
}

export async function saveListingPrintPrefs(
  scope: 'office' | 'user',
  prefs: ListingPrintPrefs['mine'],
): Promise<ListingPrintPrefs> {
  return unwrap(apiClient.PUT('/v1/listing-print/prefs', { body: { scope, prefs } }));
}

export async function downloadListingPrintPdf(caseId: string, body: ListingPrintPdfBody): Promise<void> {
  await downloadServerPdf(
    `${API_BASE_URL}/v1/cases/${encodeURIComponent(caseId)}/print.pdf`,
    `nabidka-${body.preset}.pdf`,
    body,
  );
}
